import React, { useState } from "react";
import {
  Button,
  createStyles,
  Divider,
  Select,
  TextInput,
} from "@mantine/core";
import { Modal, Box, Group, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { BillingLookups } from "../../services";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const useStyles = createStyles(() => ({
  container: {
    padding: "5px 0px 10px 0px",
    borderRadius: "12px",
    background: "#FFF",
  },
  searchInputParent: {
    width: "100%",
    margin: "20px auto",
  },
  searchInput: {
    height: "50px",
  },
  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },
  header: {
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#000 !important",
  },
  row: {
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
  },
  newinputbox: {
    background: "#FFF !important",
    border: "1px solid #E5E5E5 !important",
    borderRadius: "8px !important",
    width: "79px !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
    textAlign: "center !important",
    alignItems: "center",
    ".mantine-1vlckrq": {
      textAlign: "center",
      fontFamily: "Inter !important",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      color: "#000 !important",
    },
    ".mantine-6kqrk6": {
      textAlign: "center",
    },
  },
  searchclass: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    background: "#FFF",
    padding: "10px 14px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    marginBottom: "24px",
  },
  boxnumber: {
    display: "flex",
    flexDirection: "row",
    marginTop: "30px",
    gap: "18px",
    width: "100%",
    marginBottom: "30px",
  },
  width: {
    width: "45%",
  },
}));

const bgColor = "#FFFFFF";
const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "0px 19px",
      borderRadius: "8px",
      height: "40px",
      border: "1px solid #E5E5E5",
      marginTop: "6px",
      backgroundColor: bgColor,

      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "0px 14px",
      backgroundColor: bgColor,
      height: "40px",
      borderRadius: "8px",
      marginTop: "6px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#000"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

const ProviderServicesLookupModal = ({
  openlookup,
  setOpenLookup,
  setProviderServices,
}) => {
  const [selectedServiceObject, setSelectedServiceObject] = useState(null);
  // console.log('selectedServiceObject',selectedServiceObject);

  const [loading, setLoading] = useState(false);

  const { billinglookup } = useSelector((state) => state.billing);

  // console.log('billinglookup',billinglookup);

  const { classes } = useStyles();

  const form = useForm({
    initialValues: {
      state: "",
      region: "",
      rateBook: "",
    },
  });

  const handleClose = () => {
    setOpenLookup(false);
  };

  const handleAddService = () => {
    // if (!selectedServiceObject) return;

    // setProviderServices({
    //   servicetitle: selectedServiceObject.serviceDescription || "",
    //   servicenumber: selectedServiceObject.serviceCode || "",
    //   servicechargetype:"",
    //   servicechargeNumber: selectedServiceObject.rate || "",
    // });

    setSelectedServiceObject(null);
    form.reset();

    handleClose();
  };

  const onSave = async () => {
    try {
      // console.log('form',form.values);

      let values = form.values;

      let missingFields = [];

      Object.entries(values).forEach(
        ([key, value]) => !value && missingFields.push(key)
      );

      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      let payload = {
        ...form.values,
      };
      setLoading(true);

      let res = await BillingLookups(payload);

      if (res.status === 200) {
        setLoading(false);
      }

      // console.log('res',res);
    } catch (error) {
      console.log("error", error);
    }
  };

  const renderContent = () => {
    return (
      <>
        <Box style={{ marginTop: "45px" }}>
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <Group className={classes.boxnumber}>
              <Box style={{ width: "20%" }}>
                <Text ff="Inter" fz={14} fw={500} color="#414651">
                  Select State
                </Text>
                <CustomSelectBox
                  //  value={knownIllnessField.servicechargetype}
                  //  onChange={handleChange}
                  // onChange={(e, option) => handleChange(e, option)}
                  // onChange={(value) =>
                  //   handleChange("servicechargetype", value)
                  // }
                  placeholder={"state"}
                  // value={providerservices.servicechargetype}
                  withAsterisk
                  data={[{ value: "Arizona", label: "Arizona" }]}
                  // onChange={(value) =>
                  //   handleServiceCostChange("servicechargetype", value)
                  // }

                  {...form.getInputProps("state")}
                />
              </Box>
              <Box style={{ width: "20%" }}>
                <Text ff="Inter" fz={14} fw={500} color="#344054">
                  Select Region
                </Text>
                <CustomSelectBox
                  placeholder={"region"}
                  withAsterisk
                  data={[
                    { value: "FFS", label: "FFS" },
                    { value: "MCO", label: "MCO" },
                    { value: "Flagstaff", label: "Flagstaff" },
                  ]}
                  {...form.getInputProps("region")}
                />
              </Box>

              <Box style={{ width: "53%" }}>
                <Text ff="Inter" fz={14} fw={500} color="#344054">
                  Select Rate Book
                </Text>
                <CustomSelectBox
                  placeholder={"book"}
                  withAsterisk
                  data={[
                    {
                      value: "Community",
                      label:
                        "FFS Home and Community Based Services (HCBS) Rates",
                    },
                    {
                      value: "health",
                      label:
                        "Arizona - FFS & MCO Behavioral Health Outpatient Rates",
                    },
                  ]}
                  {...form.getInputProps("rateBook")}
                />
              </Box>
            </Group>

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "20px",
              }}
            >
              <Button
                type="submit"
                c={"#FFF"}
                // onClick={onSave}
                loading={loading}
                variant="fixed"
                bg={"black"}
                radius={8}
                size="sm"
                w={"100%"}
              >
                Find Rate
              </Button>
            </Box>
          </form>

          <Divider></Divider>

          <Group className={classes.boxnumber}>
            <Box style={{ width: "53%" }}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Service Title
              </Text>

              <CustomSelectBox
                id="servicedeatail"
                size="sm"
                withAsterisk
                data={Array.from(
                  new Set(
                    billinglookup &&
                      billinglookup?.billinglookup?.map(
                        (obj) => obj.serviceDescription
                      )
                  )
                )
                  ?.sort()
                  ?.map((serviceDescription) => ({
                    value: serviceDescription,
                    label: serviceDescription,
                  }))}
                onChange={(selectedValue) => {
                  const matched = billinglookup?.billinglookup?.find(
                    (obj) => obj.serviceDescription === selectedValue
                  );
                  setSelectedServiceObject(matched);
                }}
                searchable
              />
            </Box>

            <Box style={{ width: "20%" }}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Service Code
              </Text>
              <CustomTextInput
                name="servicenumber"
                value={selectedServiceObject?.serviceCode}
                // value={knownIllnessField?.servicenumber}
                // onChange={handleChange}
                //onChange={(e, option) => handleChange(e, option)}
                //   onChange={(e) =>
                //     handleServiceCostChange("servicenumber", e.target.value)
                //   }
                // disabled={true}
                readOnly
                size="sm"
              />
            </Box>

            <Box style={{ width: "20%" }}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Rate Amount
              </Text>
              <CustomTextInput
                name="servicetitle"
                value={selectedServiceObject?.rate}
                size="sm"
                // disabled={true}
                readOnly
              />
            </Box>
          </Group>
        </Box>
      </>
    );
  };

  return (
    <Modal
      opened={openlookup}
      size={600}
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1000}
      centered
      title={"Lookup Rates"}
      sx={{
        ".mantine-1fholi4": {
          color: "#000",
        },
      }}
      styles={{
        title: {
          color: "#000",
          fontWeight: "bold",
          fontSize: "24px",
          borderRadius: "12px 12px 0px 0px",
          background: "#FFF",
          boxShadow:
            "var(--sds-size-depth-0) var(--sds-size-depth-025) var(--sds-size-depth-100) var(--sds-size-depth-0) var(--sds-color-black-100);",
        },
      }}
    >
      {renderContent()}

      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "30px",
          marginBottom: "20px",
        }}
      >
        <Button
          type="button"
          c={"#FFF"}
          onClick={handleAddService}
          variant="fixed"
          bg={"black"}
          radius={8}
          size="sm"
          w={"100%"}
        >
          + Add Rate
        </Button>
      </Box>
    </Modal>
  );
};

export default ProviderServicesLookupModal;
